<script setup>
import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Cliente

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-text-field class="c-campo__input"
                    label="Cliente"
                    :value="props?.dado?.clienteNome"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

            <div class="c-conjunto-de-campos">

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Cliente - Pedido de Compra"
                        :value="props?.dado?.clientePedidoDeCompra"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Cliente - Email XML"
                        :value="props?.dado?.clienteEmailXML"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

            </div>

            <div class="c-conjunto-de-campos">

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Contato Comercial"
                        :value="props?.dado?.solicitacaoDeOrcamentoContatoComercialNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Contrato Técnico"
                        :value="props?.dado?.solicitacaoDeOrcamentoContatoTecnicoNome"
                        prepend-icon="mdi-account"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

</style>